import { Expose } from "class-transformer";
import { IsDefined, IsNumber, IsString } from "class-validator";

export class Company {
  @Expose()
  @IsDefined()
  @IsNumber()
  id!: number;

  @Expose()
  @IsDefined()
  @IsString()
  name!: string;
  
  @Expose()
  @IsDefined()
  @IsString()
  taxNumber!: string;

  @Expose()
  @IsDefined()
  @IsString()
  code!: string;
}
